export class HopperOctopusOptions {
  apiUrl?: string;
  clientId?: string;
}
